// start:ng42.barrel
import './corporate-contact-picker-popup.controller';
// end:ng42.barrel

